import ReactGA from 'react-ga4';

/**
 * Initializes Google Analytics 4 (GA4) using the Google Analytics Measurement ID from env variables.
 * It sets up GA4 only if the application is running in the staging or production environment.
 * Staging and production environments will have their own unique Measurement ID.
 */

export const initializeAnalytics = () => {
    const env = process.env.REACT_APP_ENV;
    const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

    if (!gaMeasurementId) {
        console.warn('REACT_APP_GA_MEASUREMENT_ID is not set. Google Analytics will not be initialized.');
        return;
    }

    if (env === "staging" || env === "production") {
        ReactGA.initialize(gaMeasurementId, {
            // Use gaOptions to send custom dimensions with every GA event except initial_page_view.
            // gtagOptions could be used to send custom dimensions to initial_page_view only, if desired.
            gaOptions: {
                // custom dimensions to report
                scripps_brand: 'ION',
                scripps_platform: 'Web',
            }
        });
    }
}